import { html, ref } from '@genesislcap/web-core';
import type { HelpDialog } from './help-dialog';

export const HelpDialogTempate = html<HelpDialog>`
  <rapid-modal test-data-id="help-dialog" ${ref('modal')}>
    <h2 slot="top" id="title">Help</h2>

    <div id="content-text">
      <p class="p-description">
        If you require support, please contact your salesperson for any issues encountered in the application.
      </p>
      
      <p class="version">Current version: ${x => x.buildInfo}</p>
    </div>
  </rapid-modal>
`;
